module.exports = __webpack_public_path__ + "static/img/cont48 (4).6aac6d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont48 (4).jpg
// module id = AKzo
// module chunks = 0